// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  width: 100%;
  .inner-container {
    max-width: 382px;
    margin: 0 auto;
    padding: 0 27px;
  }
  .back-cta {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export default styles;
